import * as FaIcons from 'react-icons/fa';
import { IconType } from 'react-icons';

export interface UnifiedIcon {
  component: IconType;
  faName: string;  // Nom Font Awesome pour la compatibilité avec les marqueurs
  label: string;   // Label pour l'affichage
}

export const UNIFIED_ICONS: Record<string, UnifiedIcon> = {
  'Maisons vides': { 
    component: FaIcons.FaHome,
    faName: 'home',
    label: 'Maisons vides'
  },
  'Boite aux lettres': {
    component: FaIcons.FaMailBulk,
    faName: 'mail-bulk',
    label: 'Boite aux lettres'
  },
  'Maison': {
    component: FaIcons.FaHome,
    faName: 'home',
    label: 'Maison'
  },
  'Immeuble': {
    component: FaIcons.FaBuilding,
    faName: 'building',
    label: 'Immeuble'
  },
  'Entrepôt': {
    component: FaIcons.FaWarehouse,
    faName: 'warehouse',
    label: 'Entrepôt'
  },
  'Commerce': {
    component: FaIcons.FaStore,
    faName: 'store',
    label: 'Commerce'
  },
  'Industrie': {
    component: FaIcons.FaIndustry,
    faName: 'industry',
    label: 'Industrie'
  },
  'Hôtel': {
    component: FaIcons.FaHotel,
    faName: 'hotel',
    label: 'Hôtel'
  },
  'Marqueur': {
    component: FaIcons.FaMapMarkerAlt,
    faName: 'map-marker-alt',
    label: 'Marqueur'
  },
  'Carte': {
    component: FaIcons.FaMapMarked,
    faName: 'map-marked',
    label: 'Carte'
  },
  'Panneau': {
    component: FaIcons.FaMapSigns,
    faName: 'map-signs',
    label: 'Panneau'
  },
  'Boussole': {
    component: FaIcons.FaCompass,
    faName: 'compass',
    label: 'Boussole'
  },
  'Recherche': {
    component: FaIcons.FaSearchLocation,
    faName: 'search-location',
    label: 'Recherche'
  },
  'Signal': {
    component: FaIcons.FaSignal,
    faName: 'signal',
    label: 'Signal'
  },
  'Clé': {
    component: FaIcons.FaKey,
    faName: 'key',
    label: 'Clé'
  },
  'Transaction': {
    component: FaIcons.FaHandshake,
    faName: 'handshake',
    label: 'Transaction'
  },
  'Prix': {
    component: FaIcons.FaDollarSign,
    faName: 'dollar-sign',
    label: 'Prix'
  },
  'Mesure': {
    component: FaIcons.FaRuler,
    faName: 'ruler',
    label: 'Mesure'
  },
  'Ville': {
    component: FaIcons.FaCity,
    faName: 'city',
    label: 'Ville'
  },
  'Monument': {
    component: FaIcons.FaLandmark,
    faName: 'landmark',
    label: 'Monument'
  },
  'Terrain': {
    component: FaIcons.FaTree,
    faName: 'tree',
    label: 'Terrain'
  },
  'Parking': {
    component: FaIcons.FaParking,
    faName: 'parking',
    label: 'Parking'
  },
  'Route': {
    component: FaIcons.FaRoad,
    faName: 'road',
    label: 'Route'
  },
  'Favori': {
    component: FaIcons.FaHeart,
    faName: 'heart',
    label: 'Favori'
  },
  'Piscine': {
    component: FaIcons.FaSwimmingPool,
    faName: 'swimming-pool',
    label: 'Piscine'
  },
  'Prestige': {
    component: FaIcons.FaGem,
    faName: 'gem',
    label: 'Prestige'
  }
} as const;

// Icône par défaut
export const DEFAULT_UNIFIED_ICON: UnifiedIcon = {
  component: FaIcons.FaMapMarkerAlt,
  faName: 'map-marker-alt',
  label: 'Marqueur par défaut'
};

// Fonction utilitaire pour obtenir une icône
export const getUnifiedIcon = (categoryName: string): UnifiedIcon => {
  return UNIFIED_ICONS[categoryName] || DEFAULT_UNIFIED_ICON;
};

